import { render, staticRenderFns } from "./FormField.global.vue?vue&type=template&id=254d8c98&lang=pug&"
import script from "./FormField.global.vue?vue&type=script&lang=ts&"
export * from "./FormField.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports